enum HelpfulState {
	NOT_HELPFUL = -1,
	NONE = 0,
	HELPFUL = 1
}

export default HelpfulState;
